(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSFuncionarioController', SSFuncionarioController);

    SSFuncionarioController.$inject = ['SSFuncionario'];

    function SSFuncionarioController(SSFuncionario) {

        var vm = this;

        vm.sSFuncionarios = [];

        loadAll();

        function loadAll() {
            SSFuncionario.query(function(result) {
                vm.sSFuncionarios = result;
                vm.searchQuery = null;
            });
        }
    }
})();
